import Header from "../Header";
import Search from "src/components/input/Search";
import { Button } from "src/components/buttons/shadcn-button";
import { TrashIcon } from "lucide-react";
import Notification from "./Notification";
import { GenericPagination } from "src/components/ui/pagination";
import { updateSearchParams } from "src/utils";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { StateList } from "src/utils/states";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import { useEmployees } from "../EmployeeList/hook/useFetchEmployees";

const posts = ["RWO", "ITWO", "DWO", "AWO", "HRWO"];

const Announcements = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get("page") || "1", 10);
  const pagesize = 25;

  const name = searchParams.get("fullname") || "";
  const employee_code = searchParams.get("employee_code") || "";

  const [debouncedName] = useDebounce(name, 500);
  const [debouncedCode] = useDebounce(employee_code, 500);

  const [failSafePageNumber, setFailSafePageNumber] = useState(1);

  const filters = {
    page,
    pagesize,
    name: debouncedName,
    employee_code: debouncedCode,
  };

  const { data: employees=[], isLoading } = useEmployees(filters);

  // pagination
  const handleNextPage = () => {
    setFailSafePageNumber(page);
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: (page + 1).toString(),
    });
  };

  const handlePrevPage = () => {
    if (page === 1) {
      toast.error("This is the first page");
      return;
    }
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: (page - 1).toString(),
    });
  };

  const handleJumpToPage = (page: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: page.toString(),
    });
  };

  const clearAllFilters = () => {
    setSearchParams({});
  };

  return (
    <div className="mx-auto w-[85%]">
      <div className="">
        <Header title="Notification & Announcement" href="/hr" />
      </div>
      <div className="flex gap-4">
        <div className="grid grid-cols-4 gap-4 py-3 grow">
          <Search
            value={name}
            placeholder="Search by Full Name"
            onChange={(value) =>
              updateSearchParams(
                "fullname",
                value,
                setSearchParams,
                searchParams,
              )
            }
            className="border-blue-200"
          />
          <Search
            value={employee_code}
            placeholder="Search by Employee Code"
            onChange={(value) =>
              updateSearchParams(
                "employee_code",
                value,
                setSearchParams,
                searchParams,
              )
            }
            className="border-blue-200"
          />
          {/* <select
            className="select select-bordered border-blue-200 w-full max-w-xs"
            value={state}
            onChange={(e) =>
              updateSearchParams(
                "state",
                e.target.value,
                setSearchParams,
                searchParams,
              )
            }
          >
            <option disabled selected value="">
              Select State
            </option>
            {StateList.map((state) => (
              <option key={state.state} value={state.state}>
                {state.state}
              </option>
            ))}
          </select>
          <select
            className="select select-bordered border-blue-200 w-full max-w-xs"
            value={job_title}
            onChange={(e) =>
              updateSearchParams(
                "job_title",
                e.target.value,
                setSearchParams,
                searchParams,
              )
            }
          >
            <option disabled selected value="">
              Select Post
            </option>
            {posts.map((post) => (
              <option key={post} value={post}>
                {post}
              </option>
            ))}
          </select> */}
        </div>
        <div className="flex justify-end items-center">
          <Button onClick={clearAllFilters} className="hover:bg-red-200">
            <TrashIcon className="size-5" />
          </Button>
        </div>
      </div>
      <div className="mt-3 h-[75vh]">
        {isLoading ? (
          <div className="w-full h-full flex justify-center items-center">
            <span className="loading loading-dots loading-xl size-16"></span>
          </div>
        ) : (
          <Notification employees={employees} />
        )}
      </div>
      <div className="flex justify-between items-center p-3 border rounded-md rounded-t-none">
        <div className="flex items-center justify-between px-3 py-2 border rounded-md border-sky-300">
          <label className="font-semibold">Limit</label>
          <select
            value={pagesize}
            onChange={(e) => {
              setSearchParams({
                ...Object.fromEntries(searchParams),
                pagesize: e.target.value,
              });
            }}
            className="border p-1 rounded-md ml-2"
          >
            {[10, 25].map((value) => (
              <option value={value}>{value}</option>
            ))}
          </select>
        </div>
        <div className="flex-grow">
          <GenericPagination
            currentPage={page}
            onNext={handleNextPage}
            onPrev={handlePrevPage}
            jumpPage={handleJumpToPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Announcements;
